<template>
	<router-link :to="{ name: 'WatchDashboard', params: { user_uid: user_uid, watch_id: watch.id } }">
		<div class="bullet"></div>
		<avatar-picture-virtual-watch :watch_id="watch.id"/>
		<div class="name">{{ watch.profile_name }}</div>
	</router-link>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesPatientsGridWatch.vue